import { useQuery } from '@tanstack/react-query'
import {
  fetchReapproCategoryNeedAdjustments,
  fetchReapproCategoryUpcomingDeliveries,
} from '../queries/reapproNeedAdjustments.queries'

export const REAPPRO_NEED_ADJUSTMENTS_KEY = 'reapproCategoryNeedAdjustments'
export const REAPPRO_UPCOMING_DELIVERIES_KEY = 'reapproCategoryUpcomingDeliveries'

export const useReapproCategoryUpcomingDeliveries = (categoryId?: number) =>
  useQuery({
    queryKey: [REAPPRO_UPCOMING_DELIVERIES_KEY, categoryId],
    queryFn: () => fetchReapproCategoryUpcomingDeliveries(categoryId as number),
    enabled: categoryId !== undefined && !Number.isNaN(categoryId),
    staleTime: 60_000,
  })

export const useReapproCategoryNeedAdjustments = (categoryId?: number) =>
  useQuery({
    queryKey: [REAPPRO_NEED_ADJUSTMENTS_KEY, categoryId],
    queryFn: () => fetchReapproCategoryNeedAdjustments(categoryId as number),
    enabled: categoryId !== undefined && !Number.isNaN(categoryId),
    staleTime: 30_000,
  })
